import Invoice from 'src/models/leasing/Invoice';
import { Reducer, Action } from 'redux';
import { takeEvery, fork, call, select, all, put } from 'redux-saga/effects';

import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { selectors as authSelectors } from 'src/reducers/Auth';
import Api from '../api';

// Store
export interface IInvoiceState {
    invoices: Array<Invoice>;
}

const initialState: IInvoiceState = {
    invoices: undefined,
};

// Action Types
export enum actionTypes {
    GET_AGREEMENT_INVOICES = '[invoice] GET_AGREEMENT_INVOICES',
    GET_AGREEMENT_INVOICES_SUCCESS = '[invoice] GET_AGREEMENT_INVOICES_SUCCESS',
    CREATE_INVOICE = '[invoice] CREATE_INVOICE',
    CREATE_INVOICE_SUCCESS = '[invoice] CREATE_INVOICE_SUCCESS',
}

// Action Creator
export const actionCreators = {
    getInvoices: (payload: { clientNumber: number; projectNumber: number; agreementId: number }) => {
        return { type: actionTypes.GET_AGREEMENT_INVOICES, payload };
    },
    getInvoicesSuccess: (invoices: Array<Invoice>) => {
        return { type: actionTypes.GET_AGREEMENT_INVOICES_SUCCESS, payload: invoices };
    },
    createInvoice: (payload: { clientNumber: number; projectNumber: number; agreementId: number; invoice: Invoice }) => {
        return { type: actionTypes.CREATE_INVOICE, payload };
    },
};

// Reducer
const reducer: Reducer<IInvoiceState> = (state: IInvoiceState = initialState, action: Action) => {
    switch (action.type) {
        case actionTypes.GET_AGREEMENT_INVOICES: {
            return {
                ...state,
                invoices: undefined,
            };
        }
        case actionTypes.GET_AGREEMENT_INVOICES_SUCCESS: {
            const payload = (action as { type: string; payload: Array<Invoice> }).payload;
            return {
                ...state,
                invoices: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

// Side-Effects
const sagas = {
    getAgreementInvoices: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; agreementId: number };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, agreementId } = action.payload;

        const [result] = yield all([call(Api.Invoice.getAgreementInvoices, clientNumber, projectNumber, agreementId, jwt)]);

        yield put(actionCreators.getInvoicesSuccess(result));
    },
    createInvoice: function* (action: {
        type: string;
        payload: { clientNumber: number; projectNumber: number; agreementId: number; invoice: Invoice };
    }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { clientNumber, projectNumber, agreementId, invoice } = action.payload;

        yield call(Api.Invoice.createInvoice, clientNumber, projectNumber, agreementId, invoice, jwt);
        yield put(layoutActionCreators.hideDialog());
        yield put(actionCreators.getInvoices({ clientNumber, projectNumber, agreementId }));
    },
};

// Watches
const watches = {
    getAgreementInvoices: function* () {
        yield takeEvery(actionTypes.GET_AGREEMENT_INVOICES, sagas.getAgreementInvoices);
    },
    createInvoice: function* () {
        yield takeEvery(actionTypes.CREATE_INVOICE, sagas.createInvoice);
    },
};

// Forks
export function* saga() {
    yield fork(watches.getAgreementInvoices);
    yield fork(watches.createInvoice);
}



// WEBPACK FOOTER //
// ./src/reducers/Invoice.ts